<template>
    <form id="filter-form" @submit.prevent="">
        <div class="row">
            <div class="col-lg-6"
                    :class="provider.getConfig('inputFilterClass')"
                    >
                <div class="input-group has-search">
                    <span id="basic-addon1" class="input-group-text border-start-0">
                        <i :class="busy ? 'fa-pulse fa-spinner' : 'fa-search'"
                           class="fa form-control-feedback m-0"
                        ></i>
                    </span>
                    <input id="search"
                           v-model="search"
                           autocomplete="false"
                           class="job-title form-control border"
                           name="search"
                           placeholder="Jobtitel"
                           type="text">
                </div>
            </div>

            <div v-if="provider.getConfig('show_city_filter')"
            class="col-lg-6"
            :class="provider.getConfig('inputFilterClass')"
            >
                <city-filter></city-filter>
            </div>
        </div>
        <div class="filter">
            <div class="d-flex justify-content-center d-md-none">
                <button v-if="!mobileFiltersExpanded"
                        id="mobile-filter"
                        class="btn btn-primary collapsed primary lift text-white"
                        @click="showMobileFilters"
                >
                    Filter einblenden
                </button>
            </div>
            <div ref="mobileFiltersCollapse" class="collapse collapse-md pb-2">
                <h3 class="border-bottom d-md-none">
                    Filter
                    <a id="close-mobile-filter" class="btn btn-link" data-target="#collapseFilters"
                       data-toggle="collapse" @click="hideMobileFilters">
                        <i class="fas fa-times fa-lg"></i>
                    </a>
                </h3>
                <div class="row">
                    <template v-for="(filter, i) in provider.filterNames()">
                        <div :class="['col-lg-3 pb-1', 'order-md-' + (i+1)]">
                            <select-filter
                                :class="filter + '_filter'"
                                :filterName="filter"
                            ></select-filter>
                            <display-filter
                                :filterName="filter"
                                class="display-filters my-2"
                            ></display-filter>
                        </div>
                    </template>
                    <div class="col-lg-3 order-md-5">
                        <button
                            id="deselect-all"
                            class="btn w-100"
                            :class="provider.getConfig('btnDeleteFiltersClass')"
                            @click="provider.resetAll()"
                        >
                            Alle Filter löschen
                        </button>
                    </div>
                </div>
                <div class="container form-row mt-3 ms-0">
                    <div class="row mb-3 mb-lg-0">
                        <check-filter
                            v-for="filter in checkFilters"
                            :filter="filter"
                            class="col-12 col-sm-auto ps-0 me-3"
                        ></check-filter>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script lang="ts" setup>
import {Collapse} from 'bootstrap';
import {inject, ref, computed} from "vue";
import {KeyJobApiProvider} from "../symbols.ts";
import type JobApiProvider from "../JobApiProvider.ts";
import CityFilter from "./CityFilter.vue";
import SelectFilter from "./SelectFilter.vue";
import DisplayFilter from "./DisplayFilter.vue";
import CheckFilter from "./CheckFilter.vue";

const provider = inject<JobApiProvider>(KeyJobApiProvider) as JobApiProvider;

const busy = provider.busy();

const checkFilters = provider.getCheckFilters();

const search = computed({
  get: () => provider.getSearch().value,
  set: (val) => provider.search(val),
});

const mobileFiltersCollapse = ref<HTMLElement>();
const mobileFiltersExpanded = ref(false);

const showMobileFilters = () => {
    Collapse.getOrCreateInstance(mobileFiltersCollapse.value).show();
    mobileFiltersExpanded.value = true;
}

const hideMobileFilters = () => {
    Collapse.getOrCreateInstance(mobileFiltersCollapse.value).hide();
    mobileFiltersExpanded.value = false;
}

</script>
